import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InstagramIcon from "@material-ui/icons/Instagram";
import Draggable from "react-draggable";

const TikTokWidget = () => {
  const language = useSelector((state) => state.store.language);
  const enable_tik_tok_widget = useSelector(
    (state) => state.store.store.settings.enable_tik_tok_widget
  );
  const link_tiktok = useSelector(
    (state) => state.store.store.settings.link_tiktok
  );
  const enable_ebutler = useSelector(
    (state) => state.store.store.settings.enable_ebutler_widget
  );
  const ebutler_company_id = useSelector(
    (state) => state.store.store.settings.link_ebutler
  );
  const enable_ebutler_staff = useSelector(
    (state) => state.store.store.settings.enable_ebutler_widget_staff
  );
  const isEbutlerWidgetEnabled =
    enable_ebutler && ebutler_company_id && enable_ebutler_staff;

  const [shouldShow, setShouldShow] = useState(false);
  const [dragging, setDragging] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShouldShow(true);
    }, 50);
  }, []);

  const handleLinkClick = () => {
    window.open(link_tiktok, "_blank");
  };

  const onDrag = (event) => {
    event.preventDefault();
    if (!dragging) setDragging(true);
  };

  const onStop = (event) => {
    event.preventDefault();
    setDragging(false);
    if (!dragging) {
      handleLinkClick();
    }
  };
  const TikTokIcon = ({ color = "#0000000" }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 333335 333336"
        shape-rendering="geometricPrecision"
        text-rendering="geometricPrecision"
        image-rendering="optimizeQuality"
        fill-rule="evenodd"
        clip-rule="evenodd"
        width="60%"
        height="60%"
      >
        <path
          d="M72464 0h188407c39856 0 72464 32609 72464 72465v188407c0 39855-32608 72464-72464 72464H72464C32608 333336 0 300727 0 260872V72465C0 32609 32608 0 72464 0zm127664 70642c337 2877 825 5661 1461 8341l6304 2c1170 9991 4006 19119 8465 26697 7282 6745 16797 10904 28280 11641v9208c2131 444 4350 746 6659 894v29690c-14847 1462-27841-3426-42981-12531l2324 50847c0 16398 61 23892-8738 38977-20546 35222-58194 36677-82176 18323-12269-4256-23069-12466-29881-23612-19875-32516-1959-85512 55687-90966l-94 7835v1970c3105-646 6365-1144 9794-1468v31311c-12484 2057-20412 5890-24119 12980-7424 14197-4049 26526 3716 34309 16276 2796 34401-8481 31673-43351V70644h33628z"
          fill="#1a121f"
        />
        <path
          d="M200128 70642c3093 26406 18915 45038 44510 46681v25046l-165 15v-21275c-25595-1642-40311-17390-43404-43796l-27114-1v111095c3912 50005-35050 51490-49955 32531 17482 10934 45867 3826 42501-39202V70641h33628zm-72854 184165c-15319-3153-29249-12306-37430-25689-19875-32516-1959-85512 55687-90966l-94 7835c-53444 8512-58809 65920-44009 89802 5707 9209 15076 15686 25846 19019z"
          fill="#26f4ee"
        />
        <path
          d="M207892 78985c1761 15036 7293 28119 16454 36903-12866-6655-20630-19315-23062-36905l6609 2zm36580 47511c2181 463 4456 777 6824 929v29690c-14847 1462-27841-3426-42981-12531l2324 50847c0 16398 61 23892-8738 38977-21443 36760-61517 36743-85239 15810 30930 17765 84928 3857 84829-56453v-55496c15141 9105 28134 13993 42981 12530v-24302zm-99036 21460c3105-646 6365-1144 9794-1468v31311c-12484 2057-20412 5890-24119 12980-10441 19964 474 36238 14923 41365-18075-649-36010-19214-23555-43031 3707-7089 10474-10923 22958-12980v-28177z"
          fill="#fb2c53"
        />
        <path
          d="M201068 77313c3093 26406 17809 42154 43404 43796v29689c-14847 1462-27841-3425-42981-12530v55496c119 72433-77802 77945-100063 42025-14800-23881-9435-81290 44009-89802v30147c-12483 2057-19250 5891-22958 12980-22909 43808 56997 69872 51475-706V77313l27114 1z"
          fill="#fefefe"
        />
      </svg>
    );
  };

  if (!enable_tik_tok_widget || !link_tiktok) return null;

  return shouldShow ? (
    <Draggable axis="y" onDrag={onDrag} onStop={onStop}>
      <div
        className={"tiktok-widget-background"}
        style={{
          boxShadow: "rgb(0 0 0 / 15%) 0px 1px 3px 1px ",
          color: "white",
          fontSize: "1.5em",
          height: "60px ",
          margin: "0px ",
          position: "fixed ",
          bottom: "268px",
          zIndex: "1500",
          direction: language === "english" ? "rtl" : "ltr",
          right: language === "english" ? "0px" : "",
          left: language === "english" ? "" : "0px",
          width: "40px",
          borderRadius:
            language === "english" ? "5px 0px 0px 5px" : "0px 5px 5px 0px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TikTokIcon />
      </div>
    </Draggable>
  ) : null;
};

export default TikTokWidget;
